import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function InventoryAdjustment() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Reference No",
      accessorKey: "ReferenceNo",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "	Ingredient Count	",
      accessorKey: "Count",
    },
    {
      header: "Responsible Person	",
      accessorKey: "Responsible",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
   
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },
  ]);
  const [data] = useState([
    {
      SN: 1,
      ReferenceNo: "00001",
      Date: "2023/11/08	",
      Count	: "1",
      Responsible	: "mamdouh	",
      Vat: "",     
      AddedBy: "Demo Test Account",
    },
    
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Inventory Adjustments",
      path: "addInventoryAdjForm"
    },
    
  ]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Inventory Adjustments"}
        buttonData={buttonData}
      />
    </main>
  );
}

export default InventoryAdjustment;
